/**
 * Entry point du bundle.
 *
 * L'import de sarah-bot.ts a un effet de bord : il enregistre le custom
 * element via @customElement('sarah-bot'). Aucun export public n'est nécessaire
 * pour les apps hôtes — elles utilisent juste `<sarah-bot>` dans leur HTML.
 */
import './sarah-bot';

// Sentinel pour debug en console
declare const __BUILD_DATE__: string;
declare const __GIT_SHA__: string;
// eslint-disable-next-line no-console
console.log(`[sarah-bot] build ${__GIT_SHA__} (${__BUILD_DATE__})`);
